var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"save-cancel-btn"},[_c('button',{staticClass:"cancel_btn",on:{"click":_vm.modalShow}},[_vm._v("отмена")]),_c('button',{staticClass:"save_btn",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.save_label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }